import { defineStore } from 'pinia'

export interface Crumb {
  name: string
  path: string
  type: 'explorer' | 'theme' | 'graffiti' | 'categorie'
}

// Crumb initial constant
const EXPLORER_CRUMB: Crumb = {
  name: 'Exploreur',
  path: '/browse',
  type: 'explorer',
}

export const useBreadcrumbsStore = defineStore('breadcrumbs', {
  state: () => ({
    history: [EXPLORER_CRUMB] as Crumb[],
    maxVisibleCrumbs: 5,
    showFullPath: false,
  }),

  getters: {
    visibleCrumbs: state => {
      if (state.history.length <= state.maxVisibleCrumbs || state.showFullPath) {
        return state.history
      }

      const firstCrumb = state.history[0]
      const lastCrumbs = state.history.slice(-1 * (state.maxVisibleCrumbs - 2))

      return [firstCrumb, { name: '...', path: '', type: 'explorer' as const }, ...lastCrumbs]
    },
  },

  actions: {
    addCrumb(route: any) {
      console.log('[Breadcrumbs] Adding crumb for route:', route.name)
      // Si on retourne à l'explorateur, on réinitialise
      if (route.name === 'browse' || route.path === '/browse') {
        this.resetBreadcrumbs()
        return
      }

      let name = ''
      let type: Crumb['type'] = 'explorer'

      // Déterminer le type et le nom selon la route
      if (route.name === 'theme-subset') {
        name = `Thématique "${decodeURIComponent(route.params.themeName as string)}"`
        type = 'theme'
      } else if (route.name === 'graffiti-detail') {
        name = `Graffiti ${route.params.id}`
        type = 'graffiti'
      } else if (route.name === 'categorie-subset') {
        name = `Catégorie "${decodeURIComponent(route.params.categorieName as string)}"`
        type = 'categorie'
      }

      // Si on n'a pas le crumb Exploreur en premier, on le remet
      if (this.history.length === 0 || this.history[0].path !== '/browse') {
        this.history = [EXPLORER_CRUMB]
      }

      // Vérifier si cette route existe déjà dans l'historique
      const existingIndex = this.history.findIndex(crumb => crumb.path === route.fullPath)

      if (existingIndex !== -1) {
        // Si la route existe, tronquer l'historique jusqu'à ce point
        this.history = this.history.slice(0, existingIndex + 1)
      } else if (name) {
        // On ajoute seulement si on a un nom valide
        // Sinon, ajouter la nouvelle miette
        this.history.push({
          name,
          path: route.fullPath,
          type,
        })
      }
    },

    resetBreadcrumbs() {
      this.history = [EXPLORER_CRUMB]
      this.showFullPath = false
    },

    initializeBreadcrumbs(route: any) {
      if (route.name === 'browse' || route.path === '/browse') {
        this.resetBreadcrumbs()
      } else {
        this.history = [EXPLORER_CRUMB]
        this.addCrumb(route)
      }
    },
  },
})
